import { AdminAppState, PlaceEntry } from '../../state';
import { getPlaces } from './get-places';

export const getPlaceEntry = (placeKey: string) => (
  state: AdminAppState,
): PlaceEntry => {
  const places = getPlaces(state);
  const entry = places[placeKey];
  if (entry) {
    return entry;
  } else {
    throw new Error(`Missing place: ${placeKey}`);
  }
};
